<script setup lang="ts">
import { computed, type PropType } from "vue";

import { HttpError } from "@/utils";
import Error403 from "@/views/403.vue";
import Error404 from "@/views/404.vue";
import Error500 from "@/views/500.vue";

const props = defineProps({
  error: {
    type: [String, Object] as PropType<string | HttpError>,
    default: "",
  },
});

const component = computed(() => {
  if (props.error instanceof HttpError) {
    switch (props.error.code) {
      case 403:
        return Error403;
      case 404:
        return Error404;
      case 500:
        return Error500;
    }
  }

  return null;
});

const componentOptions = computed(() => {
  if (props.error instanceof HttpError) {
    return props.error.options;
  }

  return {};
});
</script>

<template>
  <component :is="component" v-if="component" v-bind="componentOptions" />
  <div v-else class="text-error-dark flex h-full w-full items-center justify-center">
    {{ props.error }}
  </div>
</template>
